import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";

import TimeFilter, { Select } from "src/components/TimeFilter";
import { useRecordEvent } from "src/hooks/useRecordEvent";
import { userPlanSelector } from "src/store/system/selector";
import { useDateRange } from "src/utils/timeFilter";

import Overview from "./Overview";
import SalesAnalytics from "./SalesAnalytics";
import {
  getTourCurrentStep,
  getTourOpen,
  getTourStepType,
} from "src/store/tour/selector";

function Content() {
  const recordEvent = useRecordEvent();

  const { timeOption: timeFilter, setDateRange } = useDateRange("dashboard");
  const [view, setView] = useState("overview");

  const plan = useSelector(userPlanSelector);
  const isSalesAnalyticsAvailable = plan === "premium" || plan === "ultimate";
  const salesAnalyticsMenuItem = (
    <MenuItem value="sales-analytics" disabled={!isSalesAnalyticsAvailable}>
      Sales Analytics
    </MenuItem>
  );

  const isOpen = useSelector(getTourOpen);
  const currentStep = useSelector(getTourCurrentStep);
  const tourStep = useSelector(getTourStepType);

  useEffect(() => {
    if (tourStep === "analytics" && isOpen) {
      if (currentStep === 3) {
        setView("sales-analytics");
      }
    }
  }, [tourStep, currentStep, isOpen]);

  return (
    <div>
      <TimeFilter
        value={timeFilter}
        onChange={(v) => {
          setDateRange(v);
          recordEvent({
            type: "feature-adoption",
            feature: "dashboard-filter-change",
            filter: v,
          });
        }}
      >
        <Select
          id={"dashboard-view-select"}
          label="View"
          value={view}
          onChange={(e) => {
            const view =
              e.target.value === "sales-analytics"
                ? "sales-analytics"
                : "overview";
            setView(view);
            recordEvent({
              type: "feature-adoption",
              feature: "dashboard-view",
              view,
            });
          }}
        >
          <MenuItem value="overview">Overview</MenuItem>
          {isSalesAnalyticsAvailable ? (
            salesAnalyticsMenuItem
          ) : (
            <Tooltip title="Sales analytics are available on the Premium and Ultimate plans.">
              <span>{salesAnalyticsMenuItem}</span>
            </Tooltip>
          )}
        </Select>
      </TimeFilter>
      {view === "overview" || !isSalesAnalyticsAvailable ? (
        <Overview timeFilter={timeFilter} />
      ) : (
        <SalesAnalytics timeFilter={timeFilter} />
      )}
    </div>
  );
}

export default Content;
